import { Pipe, PipeTransform } from '@angular/core';
import { DropdownLists } from './../../helpers/dropdown-lists/dropdown-lists';

@Pipe({
  name: 'formatStatus'
})
export class FormatStatusPipe implements PipeTransform {

  	states = DropdownLists.queryStatus;
  	
  	transform(value: any, args?: any): any {
  		for (const key in this.states) {
	    	if (this.states[key] && this.states[key]['value'] == value) {
	    		return this.states[key]['name'];
	    	}
  		}
  		return "";
	}

}
